import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Evaluation/CriteriaSurveys/Domain/commands-core';
import { Component } from 'vue-facing-decorator';

@Component
export default class CriteriaSurveyCommands extends VueCqrs {

	invokeExcludeCriteriaPanelistCommandV1(workspaceId: number, surveyId: number, projectUserId: number)
	{
		const cmd = new c.ExcludeCriteriaPanelistCommandV1(workspaceId, surveyId, projectUserId);
		this.$command(cmd, projectUserId.toString());
	}

	invokeIncludeCriteriaPanelistCommandV1(workspaceId: number, surveyId: number, projectUserId: number)
	{
		const cmd = new c.IncludeCriteriaPanelistCommandV1(workspaceId, surveyId, projectUserId);
		this.$command(cmd, projectUserId.toString());
	}

	invokeChangeCriteriaPanelistVoteStrengthCommandV1(workspaceId: number, surveyId: number, projectUserId: number, oldVoteStrength: number, newVoteStrength: number)
	{
		const cmd = new c.ChangeCriteriaPanelistVoteStrengthCommandV1(workspaceId, surveyId, projectUserId, oldVoteStrength, newVoteStrength);
		this.$command(cmd, projectUserId.toString());
	}

	invokeSendEmailCommandV1(workspaceId: number, surveyId: number, projectUsersIds: number[], emailSubject: string, emailBody: string)
	{
		const cmd = new c.SendEmailCommandV1(workspaceId, surveyId, projectUsersIds, emailSubject, emailBody);
		this.$command(cmd, surveyId.toString());
	}

	invokeDeleteSurveyCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const cmd = new c.DeleteSurveyCommandV1(workspaceId, projectId, evalModelId, surveyId);
		this.$command(cmd, surveyId.toString());
	}

	invokeCreateSurveyCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, name: string, description: string, responseDueDateIsoString: string | null)
	{
		const cmd = new c.CreateSurveyCommandV1(workspaceId, projectId, evalModelId, surveyId, name, description, responseDueDateIsoString);
		this.$command(cmd, name);
	}

	invokeUpdateSurveyCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, name: string, description: string, responseDueDateIsoString: string | null)
	{
		const cmd = new c.UpdateSurveyCommandV1(workspaceId, projectId, evalModelId, surveyId, name, description, responseDueDateIsoString);
		this.$command(cmd, surveyId.toString());
	}


	invokeIncludeSubSurveyCommandV1(workspaceId: number, projectId: number, evalModelId: number, masterSurveyId: number, subSurveyId: number, voteStrength: number)
	{
		const cmd = new c.IncludeSubSurveyCommandV1(workspaceId, projectId, evalModelId, masterSurveyId, subSurveyId, voteStrength);
		this.$command(cmd, subSurveyId.toString());
	}

	invokeChangeSubSurveyVoteStrengthCommandV1(workspaceId: number, projectId: number, evalModelId: number, masterSurveyId: number, subSurveyId: number, voteStrength: number)
	{
		const cmd = new c.ChangeSubSurveyVoteStrengthCommandV1(workspaceId, projectId, evalModelId, masterSurveyId, subSurveyId, voteStrength);
		this.$command(cmd, subSurveyId.toString());
	}

	invokeExcludeSubSurveyCommandV1(workspaceId: number, projectId: number, evalModelId: number, masterSurveyId: number, subSurveyId: number)
	{
		const cmd = new c.ExcludeSubSurveyCommandV1(workspaceId, projectId, evalModelId, masterSurveyId, subSurveyId);
		this.$command(cmd, subSurveyId.toString());
	}


	invokeStartSurveyCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const cmd = new c.StartSurveyCommandV1(workspaceId, projectId, evalModelId, surveyId);
		this.$command(cmd, surveyId.toString());
	}

	invokeStopSurveyCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const cmd = new c.StopSurveyCommandV1(workspaceId, projectId, evalModelId, surveyId);
		this.$command(cmd, surveyId.toString());
	}


	invokeExportPanelistVotesToXlsCommandV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, projectUserId: number)
	{
		const cmd = new c.ExportPanelistVotesToXlsCommandV1(workspaceId, projectId, evalModelId, surveyId, projectUserId);
		this.$command(cmd, surveyId.toString());
	}

	invokeSavePanelistCriterionVotesCommandV1(workspaceId: number, evalModelId: number, surveyId: number, projectUserId: number, criterionId: number, votes: any[])
	{
		const cmd = new c.SavePanelistCriterionVotesCommandV1(workspaceId, evalModelId, surveyId, projectUserId, criterionId, votes);
		this.$command(cmd, criterionId.toString());
	}

	invokeSavePanelistVoteCommandV1(workspaceId: number, surveyId: number, projectUserId: number, questionId: string, voteValue: number | null, voteComment: string | null)
	{
		const cmd = new c.SavePanelistVoteCommandV1(workspaceId, surveyId, projectUserId, questionId, voteValue, voteComment);
		this.$command(cmd, questionId);
	}

	invokeSavePanelistVoteCommentCommandV1(workspaceId: number, surveyId: number, projectUserId: number, questionId: string, comment: string | null)
	{
		const cmd = new c.SavePanelistVoteCommentCommandV1(workspaceId, surveyId, projectUserId, questionId, comment);
		this.$command(cmd, questionId);
	}


	invokeSavePanelVoteCommandV1(workspaceId: number, surveyId: number, questionId: string, voteValue: number | null, voteComment: string | null)
	{
		const cmd = new c.SavePanelVoteCommandV1(workspaceId, surveyId, questionId, voteValue, voteComment);
		this.$command(cmd, questionId);
	}

	invokeSavePanelVoteCommentCommandV1(workspaceId: number, surveyId: number, questionId: string, comment: string | null)
	{
		const cmd = new c.SavePanelVoteCommentCommandV1(workspaceId, surveyId, questionId, comment);
		this.$command(cmd, questionId);
	}
}
